import { mapState, mapGetters } from 'vuex';
import ScanProcess from '@/modules/scan-process';

const reinitializeScan = {
  methods: {
    async reInitializeScan() {
      await ScanProcess.reInitialize(this.hasFixedScanner ? this.fixedSessionKey : '');
    },
  },
  computed: {
    ...mapGetters('mtmUser', ['hasFixedScanner']),
    ...mapState('mtmUser', ['fixedSessionKey']),
  },
};

export default reinitializeScan;
